import { render, staticRenderFns } from "./UpdatePaymentTab.vue?vue&type=template&id=2844858c&scoped=true&"
import script from "./UpdatePaymentTab.vue?vue&type=script&lang=ts&"
export * from "./UpdatePaymentTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2844858c",
  null
  
)

export default component.exports